const Footer = ({ title, subtitle }) => (
  <div className="bottom-0 mt-4 h-30 border-gray-800 bg-gray-900 border-2 rounded-md p-6">
    <h4 className="text-gray-200 font-semibold">{title}</h4>
    <p className="mt-4 text-sm font-md text-gray-300">{subtitle}</p>
  </div>
);

export default Footer;
